module.exports = __webpack_public_path__ + "static/media/FiveStages_Low_Impact_Dance_Fitness_3.c74d7d28.webp";